import { AxiosResponse } from "axios";

export const extractFilename = (response: AxiosResponse, fileName: string = 'filename') => {
  
  if (! (response && response?.headers)) return fileName;

  const disposition = response.headers['content-disposition'];

  if (disposition) {
    // Regex to extract filename or filename* (handles UTF-8 and quotes)
    const filenameMatch = disposition.match(/filename\*?=['"]?(?:UTF-8'')?([^;\r\n"']*)['"]?;?/i);
    
    if (filenameMatch && filenameMatch[1]) {
      return decodeURIComponent(filenameMatch[1]);
    }
  }
  
  return fileName;
}

export const downloadFile = (byteArray: any, fileName: string) => {
  const nav = (window.navigator as any);
  if (nav && nav.msSaveOrOpenBlob) { // IE variant
    nav.msSaveOrOpenBlob(new Blob([byteArray]), fileName);
  } else {
    const url = window.URL.createObjectURL(new Blob([byteArray]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
  }
}


export const downloadCSV = (keys: Array<string>, headers: Array<string>, lines: Array<any>, filename: string) => {

  let csvRows = [];
  if (Array.isArray(headers) && headers.length > 0) {
    csvRows.push(headers.join(','));
  }

  if (Array.isArray(lines) && lines.length > 0) {
    lines.forEach(_line => {
      let _row: Array<string> = [];
      keys.forEach( _key => {
        if (_line.hasOwnProperty(_key)) {

          const val = (typeof(_line[_key]) === 'object') ? JSON.stringify(_line[_key]) : (_line[_key] +  '');
          _row.push('"' + val.replace(/"/g, '""') + '"');
          // escape double quotes
          // enclose in double quote
        } else {
          _row.push('""');
        }
      })
      csvRows.push(_row.join(','));
    })
  }

  downloadFile(csvRows.join("\n"), filename + ".csv");
}